import React from 'react';
import './App.css';
// route
import Router from './routes';
// i18n
import './translations/i18n';
// theme
import { ThemeProvider, LinearProgress } from '@mui/material';
import theme from './theme';
// hooks
import { useEffect, useState } from 'react';
import { AUTH_TOKEN } from './constants/message';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import LoginView from './views/login';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { loginFailed, loginSuccess } from './store/authenticationSlice';
import { decode, encode } from './utils/hashString';

import axiosInstance from './lib/axios';
import { EN_ACCEPT_LANGUAGE, LA_ACCEPT_LANGUAGE } from './constants/acceptLanguageApi';
import { MERCHANT_REFRESH_TOKEN, MERCHANT_USER_FIND_BY_TOKEN } from './lib/endpoints/merchants';

import { increaseNotification, openSound } from './store/notification_slice';

import * as io from "socket.io-client";
import { ORDER_ADMIN_FIND_ONE } from './lib/endpoints/order';
import { OrderSocketModel } from './models/orderSocket';



function App() {
  const dispatch = useDispatch();

  const auth = useSelector((state: RootState) => state?.auth);

  const { i18n } = useTranslation("global");
  const [isInit, setIsInit] = useState<boolean>(false);


  const getMerchantByToken = async () => {
    try {
      const authToken = localStorage.getItem(AUTH_TOKEN);
      const token: string = authToken ? decode(JSON.parse(authToken || '')?.accessToken || '') : '';
      axios.defaults.headers.common['Authorization'] = token;
      axiosInstance.defaults.headers.common['Authorization'] = token;
      const { data: dataMerchant } = await axios.get(
        MERCHANT_USER_FIND_BY_TOKEN
      );
      dispatch(loginSuccess(dataMerchant));

    } catch (err: any) {
      if (err?.response?.status === 401) {
        try {
          const authToken = localStorage.getItem(AUTH_TOKEN);
          const refreshToken: string = authToken ? decode(JSON.parse(authToken || '')?.refreshToken || '') : '';
          axios.defaults.headers.common['Authorization'] = refreshToken;
          axiosInstance.defaults.headers.common['Authorization'] = refreshToken;

          const { data: dataRefreshToken } = await axios.post(
            MERCHANT_REFRESH_TOKEN
          );
          const { data: dataMerchant } = await axios.post(
            MERCHANT_USER_FIND_BY_TOKEN
          );
          localStorage.setItem(
            AUTH_TOKEN,
            JSON.stringify({
              accessToken: encode(refreshToken),
              refreshToken: encode(dataRefreshToken?.refreshToken),
            })
          );
          dispatch(loginSuccess(dataMerchant?.data));
        } catch (err2) {
          dispatch(loginFailed());
        }
      }
      else {
        dispatch(loginFailed());
      }

    }
  }


  const handleGetDataById = async (getId: string) => {
    try {
      const res = await axiosInstance.get(`${ORDER_ADMIN_FIND_ONE}?id=${getId}`);
      dispatch(increaseNotification(res?.data));
      dispatch(openSound());
    } catch (err) {
    }
  };

  useEffect(() => {
    if (auth?.data && !isInit) {

      const socket = io.connect(process.env.REACT_APP_SOCKET_URI || "");
      socket.on("current-order-from-user", (socket: OrderSocketModel) => {
        console.log('socket=',socket);
        if (auth?.data?.merchantId === socket?.merchantId) {
          handleGetDataById(socket?.orderId);
        }
      })
      setIsInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  useEffect(() => {
    axiosInstance.defaults.headers.common['Accept-Language'] = i18n.language === "en" ? EN_ACCEPT_LANGUAGE : LA_ACCEPT_LANGUAGE;
    if (!auth?.loggedIn) {
      axios.defaults.headers.common['Accept-Language'] = i18n.language === "en" ? EN_ACCEPT_LANGUAGE : LA_ACCEPT_LANGUAGE;
      getMerchantByToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <ThemeProvider theme={theme}>
      {
        !auth?.loggedIn
          ?
          <LinearProgress />
          :
          auth?.data
            ?
            <Router />
            :
            <LoginView />
      }
    </ThemeProvider>
  );
}

export default App;
